<template>
  <div>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <title-edit header="About" />
    <line-hr />
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        &nbsp;
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <v-app class="switch-app">
          <v-switch label="Publish" color="tcdc_color" v-model="form.is_publish"></v-switch>
        </v-app>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Branch* :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <select-option :items="optionBranch" :model="form.branch_id" @update="updateBranch" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Order :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-text-field :model="form.orders" @update="updateOrders" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Name TH* :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-text-field :model="form.name_th" @update="updateNameTH" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Name EN* :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-text-field :model="form.name_en" @update="updateNameEN" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Description TH* :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-editor :model="form.description_th" @update="updateDescriptionTH" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Description EN* :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-editor :model="form.description_en" @update="updateDescriptionEN" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Full profile TH :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-editor :model="form.full_profile_th" @update="updateFullProfileTH" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Full profile EN :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-editor :model="form.full_profile_en" @update="updateFullProfileEN" />
      </v-col>
    </div>
    <!--    <div class="row">-->
    <!--      <v-col cols="12" sm="3" class="label">-->
    <!--        <label>Image name :</label>-->
    <!--      </v-col>-->
    <!--      <v-col cols="12" sm="8" xs="12">-->
    <!--        <input-text-field :model="form.image_name" @update="updateImageName" />-->
    <!--      </v-col>-->
    <!--    </div>-->
    <!--    <div class="row">-->
    <!--      <v-col cols="12" sm="3" class="label">-->
    <!--        <label>Image path* :</label>-->
    <!--      </v-col>-->
    <!--      <v-col cols="12" sm="8" xs="12">-->
    <!--        <input-text-field :model="form.image_path" @update="updateImagePath" />-->
    <!--      </v-col>-->
    <!--    </div>-->
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Video url :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-text-field :model="form.video_url" @update="updateVideoUrl" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Template for site* :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <select-option :items="templates" :model="form.template" @update="updateTemplate" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Show dowload as zip :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <v-app class="switch-zip">
          <v-switch color="tcdc_color" v-model="form.download_show"></v-switch>
        </v-app>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Slide Image :</label>
        <div style="color: #2E8037; font-size: 12px">
          *รองรับ JPEG ,PNG ขนาดไฟล์ 1,200 x 675 px
        </div>
      </v-col>
      <v-col cols="6" sm="8">
        <v-row>
          <v-col v-for="(image, index) in form.slide_images" :key="index" cols="4">
            <v-card @click="removeSlideImage(index)">
              <v-img :src="image.slide_images_show" title="click for remove image" width="150px" height="150px" />
            </v-card>
          </v-col>
        </v-row>
        <input-image-upload id="image" menu="about" :branch_id="form.branch_id" @update="updateSlideImage" width="140px"
          height="140px" />
      </v-col>
    </div>
    <line-hr />
    <command-button @delete-info="deleteAbout" @save-info="saveAbout" @save-close="saveClose"></command-button>
    <!--        <pre>{{form}}</pre>-->
  </div>
</template>

<script>
import SaveButton from "../../components/Button/SaveButton";
import PreviewButton from "../../components/Button/PreviewButton";
import DeleteButton from "../../components/Button/DeleteButton";
import LineHr from "../../components/Icon/line-hr";
import TitleEdit from "../../components/TitleHeader/TitleEdit";
import InputTextField from "../../components/Input/InputTextField";
import SelectOption from "../../components/Input/selectOption";
import InputEditor from "../../components/Input/InputEditor";
import InputTextArea from "../../components/Input/InputTextArea";
import InputImageUpload from "../../components/Input/InputImageUpload";
import { mapState } from "vuex";
import { permissionAbout, role } from "../../util/Permission";
import Swal from 'sweetalert';
import CommandButton from "../../components/Layout/CommandButton";
import Loading from 'vue-loading-overlay';

export default {
  name: "AboutEdit",
  components: {
    CommandButton,
    InputImageUpload,
    InputTextArea,
    InputEditor,
    SelectOption,
    InputTextField,
    TitleEdit,
    LineHr,
    DeleteButton,
    PreviewButton,
    SaveButton,
    Loading
  },
  data() {
    return {
      optionBranch: [],
      permission: null,
      templates: [
        { value: null, text: "Select template TCDC about page" },
        { value: 1, text: "Main branch template" },
        // { value: 2, text: "COMMONS - TCDC CHIANGMAI - TCDC KHONKEAN" },
        { value: 3, text: "miniTCDC template" }
      ],
      save_id: null,
      isLoading: false
    };
  },
  computed: {
    permissionAbout,
    ...mapState({
      form: state => {
        return state.About.form;
      }
    })
  },
  created() {
    this.permission = role;
    this.getBranchData();
  },
  methods: {
    getBranchData() {
      this.$store.dispatch("Branch/getBranchAll").then(res => {
        this.optionBranch = [
          { text: "Select", value: "" },
          ...res.filter(val => val.branch_id !== 0).map(type => ({
            value: type.branch_id,
            text: type.branch_name_th + " (" + type.branch_name_en + ")"
          }))
        ];
      });
    },
    validateSave() {
      if (!this.form.branch_id) {
        Swal('', 'Please select Branch !', 'error');
        return false;
      } else if (!this.form.name_th) {
        Swal('', 'Please insert Name TH !', 'error');
        return false;
      } else if (!this.form.name_en) {
        Swal('', 'Please insert Name EN !', 'error');
        return false;
      } else if (!this.form.description_th) {
        Swal('', 'Please insert Description TH !', 'error');
        return false;
      } else if (!this.form.description_en) {
        Swal('', 'Please insert Description EN !', 'error');
        return false;
        // } else if (!this.form.image_path) {
        //   Swal('','Please insert Image path !','error');
        //   return false;
      } else {
        return true;
      }
    },
    saveClose() {
      this.$store
        .dispatch("About/saveAbout", {
          id: this.save_id ? this.save_id : this.form.id,
          data: this.form
        })
        .then(res => {
          Swal(res.response_msg);
          if (res.response_code == 200) {
            this.goToAboutTable();
          }
        })
        .catch(() => {
          Swal('', 'Cannot save about data', 'error');
        });
    },
    saveAbout() {
      this.isLoading = true;
      this.$store
        .dispatch("About/saveAbout", {
          id: this.save_id ? this.save_id : this.form.id,
          data: this.form
        })
        .then(res => {
          this.isLoading = false;
          Swal(res.response_msg);
          this.save_id = res.result.id;
        })
        .catch(() => {
          this.isLoading = false;
          Swal('', 'Cannot save about data', 'error');
        });
    },
    deleteAbout() {
      this.$store
        .dispatch("About/deleteAbout", this.form.id)
        .then(res => {
          Swal(res.response_msg);
          if (res.response_code == 200) {
            this.goToAboutTable();
          }
        })
        .catch(() => {
          Swal('', 'Cannot delete about data', 'error');
        });
    },
    goToAboutTable() {
      this.$router.push("/about/about");
    },
    updateOrders(val) {
      this.form.orders = val;
    },
    updateBranch(val) {
      this.form.branch_id = val;
    },
    updateTemplate(val) {
      this.form.template = val;
    },
    updateNameTH(val) {
      this.form.name_th = val;
    },
    updateNameEN(val) {
      this.form.name_en = val;
    },
    updateDescriptionEN(val) {
      this.form.description_en = val;
    },
    updateDescriptionTH(val) {
      this.form.description_th = val;
    },
    updateFullProfileTH(val) {
      this.form.full_profile_th = val;
    },
    updateFullProfileEN(val) {
      this.form.full_profile_en = val;
    },
    updateImagePath(val) {
      this.form.image_path = val;
    },
    updateVideoUrl(val) {
      this.form.video_url = val;
    },
    updateImageName(val) {
      this.form.image_name = val;
    },
    updateSlideImage(val) {
      let slide_images_show = val.fullImagePath;
      let slide_images = val.imagePath;
      let data = {
        slide_images_show,
        slide_images
      };
      this.$store.dispatch("About/insertSlideImage", data);
    },
    removeSlideImage(index) {
      this.$store.dispatch("About/removeSlideImage", index);
    },
    updateContactEmail(val) {
      this.form.contact_email = val;
    },
    updateContactInfo(val) {
      this.form.contact_info = val;
    },
    updateViewer(val) {
      this.form.viewer = val;
    },
    updateSlugURL(val) {
      this.form.slug_url = val;
    }
  }
};
</script>

<style scoped>
@import "../../assets/css/switch.css";
</style>
